import { Icon, Intent, Position, Tag, Tooltip } from "@blueprintjs/core"
import { useState } from "react"
import { __, __cases } from "src/libs/utilities"
import { ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILayersFilterPanelProps {
   onVisible: (isVisible: boolean) => void
   onInvisible: (isInvisible: boolean) => void
}
const LayersFilterPanel = (props: ILayersFilterPanelProps): JSX.Element => {
    const { currentLanding }	        = useLandingStore( ( state: ILandingStore ) => state )
    const {isLayersTread}               = useLandingConsoleStore(( state: ILandingConsoleStore) => state )  
    const [isVisible, setIsVisible]     = useState<boolean>( true )
    const [isInvisible, setIsInvisible] = useState<boolean>( false )

    const showLabel = (): string => {
        const count =  currentLanding.sections
            .filter((s: ILandingSection) => {
                if(isVisible && isInvisible)
                    return true
                else if(isVisible)
                    return !s.isHidden
                else if(isInvisible)
                    return s.isHidden
                else
                    return true
            } )
            .length
        return count + " " + __cases(count, "section" )
    }
    const onVisible = () => {        
        if(!isInvisible && isVisible) {
            setIsInvisible( true )
            props.onInvisible( !isInvisible )
        } 
        setIsVisible( !isVisible )
        props.onVisible(!isVisible) 
    }
    const onInvisible = () => {
        if(isInvisible && !isVisible) {
            setIsVisible( !isVisible )            
            props.onVisible(!isVisible) 
        } 
        setIsInvisible( !isInvisible ) 
        props.onInvisible( !isInvisible )
    }
    return <div className='landing-select-layer-panel align-items-center'>
        <Tag 
            minimal={!isVisible}
            intent={isVisible ? Intent.DANGER : Intent.NONE}
            size="medium" 
            className="small text-light py-0 px-1 mb-1 mx-1 hover pointer" 
            onClick={ onVisible }
        >
            <Tooltip
                position={ Position.TOP}
                interactionKind="hover"
                content={ <div className="small letter-spacing-1">{__("Show all visible sections")}</div> }
                portalClassName="z-index-120" 
            >    
                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                    <Icon icon="eye-open" size={ 9 } /> 
                </div>
            </Tooltip>
        </Tag>
        <Tag 
            minimal={!isInvisible}
            intent={isInvisible ? Intent.DANGER : Intent.NONE}
            size="medium" 
            className="small text-light py-0 px-1 mb-1 mr-1 hover pointer" 
            onClick={ onInvisible }
        >
            <Tooltip
                position={Position.TOP}
                interactionKind="hover"
                content={ <div className="small letter-spacing-1">{__("Show all invisible sections")}</div> }
                portalClassName="z-index-120" 
            >    
                <div className="small letter-spacing-1 opacity_75 d-flex align-items-center ">
                    <Icon icon="eye-off" size={ 9 } /> 
                </div>
            </Tooltip>
        </Tag>
        <div className="small text-light ml-2">
            { showLabel() }
        </div>
    </div>
}
export default LayersFilterPanel